(function(angular){
	'use strict';
	
	angular
		.module('portfolioAllocationChartModule')
		.factory('PortfolioAllocationChartService', [
			'$filter',
			'$q',
			'$rootScope',
			'urlFactory',
			PortfolioAllocationChartServiceFunction
		]);
	
	function PortfolioAllocationChartServiceFunction(
		$filter,
		$q,
		$rootScope,
		urlFactory
	) {
		var factory = {
			getNestedSeriesObj: getNestedSeriesObj,
			getReitSeriesObj: getReitSeriesObj,
			getReitElementSeriesObj: getReitElementSeriesObj
		};

		function getReitSortIndex(reitPhaseLabel, isIpo) {

			var sortIndex = 0;

			if(isIpo) {
				sortIndex = 4;
			} else {
				switch(reitPhaseLabel) {
					case 'Ramping up':
						sortIndex = 1;
						break;
					case 'Stabilizing':
						sortIndex = 2;
						break;
					case 'Operating':
						sortIndex = 3;
						break;
				}
			}

			return sortIndex;
		}

		function getReitPointColor(reitPhaseLabel, isIpo, hasDefaultReit, isDefaultReit) {

			var pointColor;
			var shouldBeMuted = hasDefaultReit && !isDefaultReit;

			if(shouldBeMuted) {
				pointColor = '#d5d9dc';
			} else if(isIpo) {
				pointColor = '#242628';
			} else {
				switch(reitPhaseLabel) {
					case 'Ramping up':
						pointColor = '#3399ff';
						break;
					case 'Stabilizing':
						pointColor = '#007fff';
						break;
					case 'Operating':
						pointColor = '#0066cc';
						break;
				}
			}

			return pointColor;			
		}

		function buildReitDataPoint(rawDataPoint, isIpo, hasDefaultReit, isDefaultReit) {
			var dataPoint = {
				color: getReitPointColor(rawDataPoint.reitPhaseLabel, isIpo, hasDefaultReit, isDefaultReit),
				name: rawDataPoint.reitName,
				reitHoldingTotalValue: rawDataPoint.reitHoldingTotalValue,
				reitId: rawDataPoint.reitId,
				sortIndex: getReitSortIndex(rawDataPoint.reitPhaseLabel, isIpo),
				y: parseFloat(rawDataPoint.percentageOfPortfolio)
			};

			if(!isIpo) {
				dataPoint.reitPhaseLabel = rawDataPoint.reitPhaseLabel;
			}

			if(isDefaultReit) {
				dataPoint.z = 1;
				dataPoint.events = {
					mouseOver: undefined,
					mouseOut: undefined,
					click: undefined
				};
			} else {
				dataPoint.z = 1;
			}

			return dataPoint;
		}

		function getNestedSeriesObj(ratingAllocationData) {

			var parentSeries = {
				name: 'Allocation',
				colorByPoint: true,
				data: [],
				point: {
					events: {
						click: function(e) {
							$rootScope.$broadcast('rating.drilldown');
						},
						mouseOver: function(e) {
							$rootScope.$broadcast('rating.mouseOver', {
								rating: e.target.name,
								color: e.target.color,
								count: e.target.reitElements.count
							});
						},
						mouseOut: function(e) {
							$rootScope.$broadcast('reit.mouseOut');
						}
					}
				}
			};

			var childrenSeries = [];

			angular.forEach(ratingAllocationData, function(rating) {
				if(rating.properties && rating.properties.length) {

					var roundedPercentage = parseFloat(rating.aggregateWeightedAllocation);
					roundedPercentage = roundedPercentage * 100;
					roundedPercentage = parseFloat(roundedPercentage.toFixed(1));
					var fullRating = rating.letter + rating.subletter;

					parentSeries.data.push({
						color: rating.color,
						drilldown: fullRating,
						name: fullRating,
						reitElements: {
							count: rating.properties.length
						},
						y: roundedPercentage
					});

					var childSeriesObj = getReitElementSeriesObj(rating.properties);
					childSeriesObj.name = fullRating;
					childSeriesObj.id = fullRating;

					childrenSeries.push(childSeriesObj);
				}
			});

			if(parentSeries.data.length === 0) {
				parentSeries.data.push({
					y: 1,
					color: '#e3e6e8'
				});
				delete parentSeries.point.events;
			}

			return {
				parentSeries: parentSeries,
				childrenSeries: childrenSeries
			};
		}

		function getReitSeriesObj(rawData, defaultReitId) {
			var reitSeriesObj = {
				point: {
					events: {
						mouseOver: function(e) {
							$rootScope.$broadcast('reit.mouseOver', e.target.reitId);
						},
						mouseOut: function(e) {
							$rootScope.$broadcast('reit.mouseOut', e.target.reitId);
						},
						click: function(e) {
							if(angular.isDefined(e.point.reitId)) {
								urlFactory.redirect('/activity/reit-investment/' + e.point.reitId +'/your-investment');
							}
						}
					}
				}
			};
			var data = [];
			var hasActiveIpoShareholdings = angular.isDefined(rawData.ipoPosition) && parseFloat(rawData.ipoPosition.reitHoldingTotalValue) > 0;
			var hasActiveRealEstateShareholdings = angular.isDefined(rawData.realEstatePositions) && parseFloat(rawData.realEstateHoldingsValueSubtotal) > 0;
			var hasDefaultReit = angular.isDefined(defaultReitId);

			if(hasActiveRealEstateShareholdings) {
				angular.forEach(rawData.realEstatePositions, function(reit, index) {
					var isDefaultReit = hasDefaultReit && parseInt(reit.reitId) === defaultReitId;
					var formattedDataPoint = buildReitDataPoint(reit, false, hasDefaultReit, isDefaultReit);
					data.push(formattedDataPoint);
				});
			}

			if(hasActiveIpoShareholdings) {
				var isDefaultReit = hasDefaultReit && parseInt(rawData.ipoPosition.reitId) === defaultReitId;
				var formattedDataPoint = buildReitDataPoint(rawData.ipoPosition, true, hasDefaultReit, isDefaultReit);
				data.push(formattedDataPoint);
			}

			if(data.length === 0) {
				data.push({
					y: 1,
					color: '#e3e6e8'
				});
			}

			data = $filter('orderBy')(data, 'sortIndex');
			reitSeriesObj.data = data;

			return reitSeriesObj;
		}

		function getReitElementSeriesObj(reitElements) {
			var reitElementSeriesObj = {
				data: [],
				point: {
					events: {
						click: function() {
							$rootScope.ModalFactory.openReitElement({
								reitElement: this.reitElement
							});
						},
						mouseOver: function(e) {
							var reitElement = e.target.reitElement;
							$rootScope.$broadcast('reitElement.mouseOver', {
								projectType: reitElement.projectType,
								city: reitElement.city,
								state: reitElement.state,
								rating: reitElement.rating
							});
						},
						mouseOut: function() {
							$rootScope.$broadcast('reitElement.mouseOut');
						}
					}
				}
			};

			angular.forEach(reitElements, function(reitElement) {
				var point = {
					color: reitElement.rating.color,
					reitElement: reitElement,
					y: reitElement.weightedAllocation
				};
				reitElementSeriesObj.data.push(point);
			});

			return reitElementSeriesObj;
		}

		return factory;
	}
})(window.angular);